export const GET_REVIEW_REQUEST = "GET_REVIEW_REQUEST";
export const GET_REVIEW_SUCCESS = "GET_REVIEW_SUCCESS";
export const GET_REVIEW_FAILURE = "GET_REVIEW_FAILURE";
export const GET_ESIGN_SUCCESS = "GET_ESIGN_SUCCESS";
export const GET_ESIGN_FAILURE = "GET_ESIGN_FAILURE";
export const GET_DOCUMENT_ID = "GET_DOCUMENT_ID"